// extracted by mini-css-extract-plugin
export default {"games":"OverflowSlider__games--2jL","game":"OverflowSlider__game--32N"};